import useActiveState from '../../lib/useActiveState'

export default function useInviteFriends() {
  const [config] = useActiveState('config')
  if (config?.inviteFriendsType == 3) {
    return '/invitefriends'
  } else if (config?.inviteFriendsType == 2) {
    return '/newinvite'
  } else {
    return '/invite'
  }
}
